var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgJquery = function SvgJquery(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 21,
    fill: "#0769AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.986 20.132c1.885 0 3.612-.63 4.947-1.672-1.386 1.826-3.682 3.02-6.28 3.02-4.231 0-7.662-3.168-7.662-7.076 0-2.167 1.055-4.106 2.716-5.404a6.679 6.679 0 0 0-1.383 4.056c0 3.908 3.43 7.076 7.662 7.076Z",
    fill: "#78CFF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.86 24.988c-2.033 1.595-4.665 2.556-7.54 2.556-6.439 0-11.66-4.827-11.66-10.782 0-2.31.786-4.45 2.123-6.204-2.521 1.978-4.121 4.93-4.121 8.226 0 5.955 5.22 10.782 11.66 10.782 3.942 0 7.427-1.809 9.537-4.578Z",
    fill: "#78CFF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31.155c-2.897 2.764-6.91 4.476-11.344 4.476-8.831 0-15.99-6.789-15.99-15.162 0-2.654.718-5.148 1.981-7.318C10.775 15.893 9 19.67 9 23.838 9 32.212 16.16 39 24.991 39c6.033 0 11.286-3.168 14.009-7.845Z",
    fill: "#78CFF5"
  })));
};

export default SvgJquery;